import { exitAllEditModesExcept } from "./exit-edit-mode";

export default function openEditMode(
	block: HTMLElement,
	triggerButton: HTMLElement,
) {
	const findHtmlEl = pm.utils.dom.findHtmlEl;

	block.classList.add("is-editing");
	triggerButton.parentElement?.classList.add("is-hidden");

	const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
	actionButtonsWrapper?.classList.remove("is-hidden");

	const contentWrapper = findHtmlEl(block, ".content-wrapper");

	if (contentWrapper) {
		contentWrapper.classList.add("is-hidden");
	}

	const editor = findHtmlEl(block, ".content-editor");

	if (editor) {
		editor.classList.remove("is-hidden");
		editor.focus();
	}

	const suffixEl = findHtmlEl(block, ".field-suffix");

	if (suffixEl) {
		suffixEl.classList.remove("is-hidden");
	}

	exitAllEditModesExcept(block);
}
